import {
    RichTableColumns,
} from 'app/types/richtable.types'
import FormErrorList from 'app/common/DomainObject/ComponentMapper/FormErrorList'
import {
    FailedUpload,
} from './UploadFeedback.types'

// eslint-disable-next-line import/prefer-default-export
export const getErrorColumn = (
    name: string | undefined,
    l: (key: string) => string,
): RichTableColumns<keyof FailedUpload> => {
    return {
        id: 'errors',
        headerProps: {
            children: l('ERROR'),
        },
        mapCellProps: ({
            errors,
        }) => {
            return {
                value: errors,
                labelPrefix: name,
            }
        },
        Cell: FormErrorList,
    }
}
